/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/*(function() {
  function cleanScreenSizeLabels() {
    const selectors = [
      '[data-filter-type="product:metafield:custom:screen_size_inch"] .gf-label',
      '[data-filter-type="product:metafield:custom:monitor_tablet_screen_size"] .gf-label'
    ];
    
    document.querySelectorAll(selectors.join(',')).forEach(label => {
      // Skip if already processed
      if (label.dataset.cleaned === 'true') return;
      
      const original = label.textContent.trim();
      const num = parseFloat(original);
      
      if (!isNaN(num)) {
        // If it's a whole number (e.g., 27.0, 32.0), show without decimal
        // If it has meaningful decimals (e.g., 10.4, 21.45), keep them
        const cleaned = Number.isInteger(num) ? num.toString() : num.toString();
        // parseFloat("27.0") = 27, parseFloat("10.4") = 10.4 — this handles it automatically
        label.textContent = num.toString();
        label.dataset.cleaned = 'true';
      }
    });
  }

  // Run on initial page load
  document.addEventListener('DOMContentLoaded', cleanScreenSizeLabels);
  
  // Run again when filters update (AJAX re-renders)
  const observer = new MutationObserver(() => {
    cleanScreenSizeLabels();
  });
  
  // Observe the filter container for changes
  document.addEventListener('DOMContentLoaded', () => {
    const filterContainer = document.querySelector('.gf-filter, #gf-tree, body');
    if (filterContainer) {
      observer.observe(filterContainer, { childList: true, subtree: true });
    }
  });
  
  // Also run immediately in case DOM is already loaded
  if (document.readyState !== 'loading') {
    cleanScreenSizeLabels();
  }
})();*/


// ═══════════════════════════════════════════════
// Sub-Categories Menu - Final Working Version
// Injects sub-categories menu into Globo filter sidebar
// ═══════════════════════════════════════════════

(function() {
  'use strict';
  
  const THRESHOLD = 6; // Number of items to show initially before "Show more"
  
  function buildSubCategoriesMenu() {
    const subCatData = document.getElementById('sub-categories-data');
    const globoTree = document.getElementById('gf-tree');
    
    if (!subCatData || !globoTree) return false;
    if (document.getElementById('sub-categories-menu')) return true;
    
    const currentHandle = subCatData.dataset.currentHandle || '';
    
    // Parse items from JSON
    let items = [];
    try {
      const jsonStr = subCatData.dataset.itemsJson || '[]';
      items = JSON.parse(jsonStr);
    } catch (e) {
      console.error('Failed to parse sub-categories JSON:', e);
      return false;
    }
    
    if (items.length === 0) return false;
    
    console.log('Sub-categories loaded:', items.length);
    
    const hasShowMore = items.length > THRESHOLD;
    const extraCount = items.length - THRESHOLD;
    
    // Build HTML
    let html = '<div id="sub-categories-menu" class="gf-option-block gf-option-sub-cat">';
    html += '<div class="gf-block-title"><div class="h3"><span>Shop by Collection</span></div></div>';
    html += '<div class="gf-block-content"><div class="gf-scroll">';
    html += '<ul class="gf-option-box sub-cat-list">';
    
    items.forEach((item, index) => {
      const isActive = item.handle === currentHandle ? 'is-active' : '';
      const isHiddenInitially = hasShowMore && index >= THRESHOLD;
      const hiddenClass = isHiddenInitially ? 'sub-cat-hidden-item' : '';
      const hiddenStyle = isHiddenInitially ? 'style="display:none;"' : '';
      
      html += '<li class="sub-cat-li ' + hiddenClass + '" data-idx="' + index + '" ' + hiddenStyle + '>';
      html += '<a href="' + item.url + '" class="sub-category-item-link ' + isActive + '" title="' + item.title + '">';
      html += '<span class="gf-label">' + item.title + '</span>';
      html += '<span class="gf-count">(' + item.count + ')</span>';
      html += '</a></li>';
    });
    
    html += '</ul>';
    
    if (hasShowMore) {
      html += '<button type="button" class="sub-cat-toggle-btn" data-state="collapsed">';
      html += 'Show more (' + extraCount + ' more)';
      html += '</button>';
    }
    
    html += '</div></div></div>';
    
    // Insert at top of Globo filter contents
    const filterContents = globoTree.querySelector('.gf-filter-contents');
    if (!filterContents) return false;
    
    filterContents.insertAdjacentHTML('afterbegin', html);
    
    // Attach Show More / Show Less toggle
    if (hasShowMore) {
      const toggleBtn = document.querySelector('#sub-categories-menu .sub-cat-toggle-btn');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const menu = document.getElementById('sub-categories-menu');
          const hiddenItems = menu.querySelectorAll('.sub-cat-hidden-item');
          const state = this.getAttribute('data-state');
          
          console.log('Toggle clicked. State:', state, 'Hidden items:', hiddenItems.length);
          
          if (state === 'collapsed') {
            // Expand - show all hidden items
            hiddenItems.forEach(function(li) {
              li.style.display = 'block';
            });
            this.textContent = 'Show less';
            this.setAttribute('data-state', 'expanded');
          } else {
            // Collapse - hide extras again
            hiddenItems.forEach(function(li) {
              li.style.display = 'none';
            });
            this.textContent = 'Show more (' + hiddenItems.length + ' more)';
            this.setAttribute('data-state', 'collapsed');
          }
          
          return false;
        });
      }
    }
    
    return true;
  }
  
  // Try to inject - retry if Globo hasn't loaded yet
  function tryInject() {
    if (!buildSubCategoriesMenu()) {
      setTimeout(tryInject, 500);
    }
  }
  
  // Start on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInject);
  } else {
    tryInject();
  }
  
  // Re-inject periodically if Globo re-renders (e.g., after filter change)
  setInterval(function() {
    if (document.getElementById('sub-categories-data') && 
        !document.getElementById('sub-categories-menu')) {
      buildSubCategoriesMenu();
    }
  }, 2000);
  
})()

;(function () {
  "use strict";

  if (window.__buysmarteAjaxAddToCart) {
    return;
  }

  window.__buysmarteAjaxAddToCart = true;

  function getSubmitter(event, form) {
    var submitter = event.submitter || document.activeElement;

    if (submitter && form.contains(submitter)) {
      return submitter;
    }

    return form.querySelector('button[type="submit"], input[type="submit"]');
  }

  function isPlainAddToCartButton(button) {
    if (!button || button.closest('buy-button')) {
      return false;
    }

    var label = (button.textContent || button.value || button.getAttribute('aria-label') || '').trim().toLowerCase();

    return label.indexOf('add to cart') !== -1;
  }

  function getQuantity(form) {
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    return Math.max(quantity || 1, 1);
  }

  function setButtonLoading(button, isLoading) {
    if (!button) {
      return;
    }

    button.toggleAttribute('disabled', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function showCartError(form, message) {
    var holder = form.closest('[data-section-type]') || form;
    var oldMessage = holder.querySelector('.cart__status-message--buysmarte');

    if (oldMessage) {
      oldMessage.remove();
    }

    var messageElement = document.createElement('div');
    messageElement.className = 'cart__status-message cart__status-message--buysmarte';
    messageElement.innerHTML = '<div class="alert alert--error"><p>' + message + '</p></div>';
    holder.appendChild(messageElement);
  }

  async function ajaxAddToCart(form, button) {
    if (form.dataset.buysmarteAdding === 'true') {
      return;
    }

    form.dataset.buysmarteAdding = 'true';
    var quantity = getQuantity(form);

    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    setButtonLoading(button, true);

    try {
      var body = new FormData(form);

      if (!body.get('quantity')) {
        body.set('quantity', '1');
      }

      var cartAddUrl = window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add';
      var response = await fetch(cartAddUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        body: body,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      var payload = await response.json().catch(function () {
        return null;
      });

      if (!response.ok) {
        showCartError(form, payload && payload.description ? payload.description : 'This product could not be added to the cart.');
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        return;
      }

      form.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          button: button,
          variant: payload && payload.variant_id ? payload.variant_id : null,
          quantity: quantity,
          productAdded: true
        }
      }));
    } catch (error) {
      showCartError(form, 'This product could not be added to the cart.');
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    } finally {
      setButtonLoading(button, false);
      form.dataset.buysmarteAdding = 'false';
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : event.target.parentElement;
    var button = target && target.closest('button, input[type="submit"]');

    if (!button) {
      return;
    }

    var form = button.closest('form[action*="/cart/add"]');

    if (!form || !isPlainAddToCartButton(button)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    ajaxAddToCart(form, button);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) {
      return;
    }

    var button = getSubmitter(event, form);

    if (!isPlainAddToCartButton(button)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    ajaxAddToCart(form, button);
  }, true);
})();
;